import { s as styleInject } from './style-inject.es-746bb8ed.js';

var css_248z = "._1IUhX{height:100%;position:absolute;top:0;width:100%;z-index:0}[dir] ._1IUhX{border:0}[dir=ltr] ._1IUhX{left:0}[dir=rtl] ._1IUhX{right:0}.cYcVi{bottom:0;position:absolute;top:0;z-index:3}[dir=ltr] .cYcVi{left:0;right:0}[dir=rtl] .cYcVi{left:0;right:0}.cZYzi{height:0;overflow:hidden;position:relative}[dir] .cZYzi{padding-bottom:56.25%}@media only screen and (max-width:640px){.cZYzi{min-width:auto}}";
var styles = {"video_player":"_1IUhX","videoOverlay":"cYcVi","video_container":"cZYzi"};
styleInject(css_248z);

export { styles as s };
//# sourceMappingURL=video-viewer-200c0e68.js.map
